import { StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({

  //PAGE 1

  pagePage1: {
    padding: 20,
    backgroundColor: '#ffffff',
    height: '100%', // Ensure content fits within the page
  },
  contentImgDocPage1: {
    flexDirection: 'column',
    justifyContent: 'center',
    paddingRight: 10,
    paddingLeft: 40,
    marginBottom: 10,  // Small margin below the first image

  },
  ImgdocPage1: {
    width: 467,
    height: 323,
    flexShrink: 0,
    marginTop: "40px",
    position: "relative",
    justifyContent: 'center',
    marginLeft: "20px"

  },
  contentImgBar: {
    justifyContent: 'center',
    height: '20%',
    paddingLeft: 420
  },
  ImgBar: {
    width: 114,
    height: 44,
    flexShrink: 0,

  },
  footerContainer: {
    position: 'absolute',
    bottom: 20,
    left: 0,
    right: 0,
    textAlign: 'center',
    fontSize: 10,
    paddingTop: 10,
    height: '10%', // Restrict footer height
  },

  //END OF PAGE1




  //PAGE 2

  pagePage2: {
    padding: 20,

  },

  parentContainerPage2: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    width: '100%',
    maxHeight: '100%',  // Restrict the container to not exceed the page height
    paddingBottom: 5,
  },



  leftContainerPage2: {
    flexDirection: 'column',
    justifyContent: 'flex-start',
    padding: 10,
    marginBottom: 10,
    width: 258,
    height: 565,
    alignItems: 'stretch',
  },

  rightContainerPage2: {
    position: 'relative',
    top: 30,
    width: 250,
    height: 562,
    alignItems: 'flex-start',
    backgroundColor: '#CCECFF',
    paddingRight: 5,
    // marginLeft: -20, // Removed or adjusted
  },

  leftColumnPage2: {
    marginBottom: "5px",
  },

  rightColumnPage2: {
    top: 5,
    left: 32,
    width: 220,
  },


  sectionHeaderPage2: {
    fontFamily: 'Roboto',
    fontSize: 10,
    marginBottom: 2,
    fontWeight: '900',
    color: '#006080',
    width: 300,
  },

  TitleBottomBorderPage2: {
    position: "relative",
    zIndex: 500,
    top: 8,
    width: 350, // Adjust this width as needed to control the length of the border
    height: 1, // Thickness of the border
    backgroundColor: '#bfbfbf',
    marginTop: 2, // Space between the text and the border
    fontFamily: 'Roboto'
  },



  TitleBottomBorderTwoPage2: {
    position: "relative",
    zIndex: -500,
    left: 10,
    bottom: 420,
    width: 350, // Adjust this width as needed to control the length of the border
    height: 1, // Thickness of the border
    backgroundColor: '#bfbfbf',
    marginTop: 12, // Space between the text and the border
    fontFamily: 'Roboto'
  },

  TitleBottomBorderThreePage2: {
    position: "relative",
    zIndex: -500,
    left: 10,
    bottom: 335,
    width: 350, // Adjust this width as needed to control the length of the border
    height: 1, // Thickness of the border
    backgroundColor: '#bfbfbf',
    marginTop: 8, // Space between the text and the border
    fontFamily: 'Roboto'
  },

  TitleBottomBorderFourPage2: {
    position: "relative",
    zIndex: -500,
    left: 10,
    bottom: 155,
    width: 350, // Adjust this width as needed to control the length of the border
    height: 1, // Thickness of the border
    backgroundColor: '#bfbfbf',
    marginTop: -3, // Space between the text and the border
    fontFamily: 'Roboto'
  },

  sectionHeaderRightPage2: {
    fontSize: 7,
    marginBottom: 5,
    color: '#292929',
    fontWeight: 'bold',
    marginBottom: "15px",
    fontFamily: "Roboto"
  },

  sectionHeaderInventionPage2: {
    fontSize: 6,
    marginBottom: 8,
    color: '#292929',
    fontWeight: 'bold',
    marginBottom: "15px",
    fontFamily: "Roboto"
  },

  sectionHeaderRightsPage2: {
    top: 5,
    fontFamily: "Roboto",
    fontSize: 7,
    marginBottom: 15,
    color: '#292929',
    fontWeight: 'bold',
    marginBottom: "15px",
    fontFamily: "Roboto",
    marginTop: "20px"
  },

  rowContainerPage2: {
    position: 'relative',
    top: 10,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    width: '100%',
    marginBottom: 10, // Add this line to create space between rows
  },

  labelPage2: {
    position: 'relative',
    fontFamily: "Roboto",
    top: 2,
    fontSize: 6,
    width: '80%',
    marginBottom: "5px",
    color: "#292929",
  },

  actualContainerPage2: {
    position: 'absolute', // Use absolute positioning
    backgroundColor: "#ffffff",
    left: 250,
    width: 70,
    height: 20
  },

  actualTextPage2: {
    left: 5,
    top: 4,
    fontFamily: "italicFamily",
    fontSize: 6,
    color: "#808080",
    fontWeight: "400"
  },

  label2Page2: {
    position: 'relative',
    fontFamily: "Roboto",
    fontSize: 8,
    width: '100%',
    marginBottom: "20px",
    color: "#292929",
  },

  valueContainerPage2: {
    height: 13,
    padding: 2,
    top: 8,
    width: '255px',
    backgroundColor: '#f2f2f2',
    marginBottom: '5px',
    alignSelf: 'flex-end',  // Ensures the container aligns to the right within the flex row
    marginLeft: 'auto',     // Pushes the container to the right side
    left: "75px",
    position: 'relative',  // Set relative position to contain absolutely positioned children
    zIndex: 1,  // Ensure the container is above other elements, if necessary
  },

  valueContainerYMMPage2: {
    height: 20,
    padding: 2,
    top: 8,
    width: '255px',
    backgroundColor: '#f2f2f2',
    marginBottom: '5px',
    alignSelf: 'flex-end',  // Ensures the container aligns to the right within the flex row
    marginLeft: 'auto',     // Pushes the container to the right side
    left: "75px",
    position: 'relative',  // Set relative position to contain absolutely positioned children
    zIndex: 1,  // Ensure the container is above other elements, if necessary
  },

  valuePage2: {
    textTransform: 'uppercase', // This makes all text uppercase
    position: "absolute",
    padding: 2,
    fontFamily: "Roboto",
    fontSize: 6,
    marginBottom: '4px',
    fontWeight: '400',
    top: 2,
  },

  vehiclePage2: {
    top: 1,
    width: '100%',
    textAlign: 'center',
    bottom: 43,
  },

  bodyDamagePage2: {
    color: '#545454',
    textAlign: 'center',
    fontSize: 8,
    top: 30,
    fontFamily: "italicFamily",
  },

  rectangleParentPage2: {
    width: 258,
    height: 80,
    marginBottom: 20,
  },

  rectangleIconPage2: {
    width: 205,
    height: 120,
    top: 50,  // Move the car down by 20px
    left: 40,
  },

  uncheckedBoxPage2: {
    width: 7,
    height: 7,
    width: 7,
    height: 7,
    backgroundColor: '#f2f2f2', // Light background for unchecked state
    borderColor: '#C7C7C7', // Remove blue border
    borderRadius: '20%',
  },

  checkboxPage2: {
    width: 7,
    height: 7,
    position: 'absolute',
    borderRadius: '1px',
    backgroundColor: '#0073ff',
    borderColor: '#C7C7C7', // Remove blue border
    borderRadius: '20%',
    top: 29,
    left: 180
  },

  uncheckedBoxOtherPage2: {
    width: 7,
    height: 7,
    width: 7,
    height: 7,
    backgroundColor: '#f2f2f2', // Light background for unchecked state
    borderColor: '#C7C7C7', // Remove blue border
    borderRadius: '50%',
  },

  checkboxOtherPage2: {
    width: 7,
    height: 7,
    position: 'absolute',
    backgroundColor: '#0073ff',
    borderRadius: '1px',
    color: '#0073ff',
    borderColor: '#C7C7C7', // Remove blue border
    borderRadius: '50%',
    top: 29,
    left: 180
  },

  rightFrontPage2: {
    fontFamily: "italicFamily",
    color: '#808080',
    position: 'absolute',
    top: 2,
    left: 0,
    fontSize: 6,
  },
  leftFrontPage2: {
    fontFamily: "italicFamily",
    color: '#808080',
    position: 'absolute',
    top: 70,
    left: 0,
    fontSize: 6,
  },

  leftRearPage2: {
    fontFamily: "italicFamily",
    fontSize: 6,
    color: '#808080',
    position: 'absolute',
    top: 63,
    left: 224,
  },

  rightRearPage2: {
    fontFamily: "italicFamily",
    fontSize: 6,
    color: '#808080',
    position: 'absolute',
    top: 10,
    left: 221,
  },

  paragraphPage2: {
    fontFamily: "Roboto", // Define a fonte como Roboto, com fallback para sans-serif
    fontWeight: "400",
    fontSize: 6,
    marginBottom: "15px",
    color: "#292929",
    lineHeight: "1.2"
  },


  italicoPage2: {
    fontStyle: 'italic',
  },


  //END OF PAGE 2




  //PAGE 3

  pagePage3: {
    padding: 20,
    backgroundColor: '#ffffff',
  },

  contentPage3: {
    marginBottom: 20,
  },

  greyContainer1Page3: {
    position: 'absolute',
    backgroundColor: '#f2f2f2',
    width: 150,
    height: 10,
    left: 123,
    top: 19,   // Position below greyContainer1
  },

  greyContainer2Page3: {
    position: 'absolute',
    backgroundColor: '#f2f2f2',
    width: 150,
    height: 10,
    left: 123,
    top: 47,   // Position below greyContainer1
  },

  greyContainer3Page3: {
    position: 'absolute',
    backgroundColor: '#f2f2f2',
    width: 150,
    height: 10,
    left: 123,
    top: 65,   // Position below greyContainer1
  },

  greyContainer4Page3: {
    position: 'absolute',
    backgroundColor: '#f2f2f2',
    width: 150,
    height: 10,
    left: 123,
    top: 94,   // Position below greyContainer1
  },

  greyContainer5Page3: {
    position: 'absolute',
    backgroundColor: '#f2f2f2',
    width: 150,
    height: 10,
    left: 123,
    top: 121,   // Position below greyContainer1
  },

  greyContainer6Page3: {
    position: 'absolute',
    backgroundColor: '#f2f2f2',
    width: 150,
    height: 10,
    left: 123,
    top: 156,   // Position below greyContainer1
  },

  tableContainerPage3: {
    position: 'absolute',  // Make the table fixed at a specific position
    top: 430,              // Adjust the top position to where you want the table
    left: 10,              // Adjust the left position to control horizontal alignment
    width: 273,
  },

  headerRowPage3: {
    marginTop: 5,
    flexDirection: 'row',
    justifyContent: 'space-between',
    backgroundColor: '#CCECFF',  // Light blue background for header rows
    height: 14,
    fontFamily: 'Roboto',
    textAlign: 'center'
  },

  headerTextPage3: {
    fontFamily: 'Roboto',
    fontWeight: 'bold',
    fontSize: 8,
    left: 3,
    top: 2,
    textAlign: 'left',
    width: '50%',
  },

  parentContainerPage3: {
    position: 'relative',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    width: '100%',
    maxHeight: '100%',  // Restrict the container to not exceed the page height
    paddingBottom: 5,
  },

  sectionHeaderPage3: {
    fontFamily: 'Roboto',
    fontSize: 10,
    top: 5,
    marginBottom: 1,
    fontWeight: '900',
    color: '#006080',
    width: 300,
  },

  sectionHeaderTwoPage3: {
    position: 'absolute',
    fontFamily: 'Roboto',
    fontSize: 10,
    top: 400,
    fontWeight: '900',
    color: '#006080',
    width: 300,
    left: 11
  },

  TitleBottomBorderTwoPage3: {
    position: 'absolute',
    top: 418,
    width: 350, // Adjust this width as needed to control the length of the border
    height: 1, // Thickness of the border
    backgroundColor: '#bfbfbf',
    marginTop: 2, // Space between the text and the border
    fontFamily: 'Roboto',
    left: 11
  },

  fixedCellPage3: {
    width: 60,          // Fixed width for cells with short text
    fontSize: 10,
    textAlign: 'left',
    fontFamily: 'Roboto',
    fontSize: 8,
    left: 5,
    zIndex: 999
  },

  cellPage3: {
    width: 60,              // Fixed width for cells with short text
    fontSize: 10,
    textAlign: 'center',
    fontFamily: 'Roboto',
    fontSize: 7,
    display: 'flex',        // Flexbox layout for centering
    justifyContent: 'center', // Centers horizontally
    alignItems: 'center'     // Centers vertically
  },

  signsContainer: {
    position: 'absolute',
    top: 442, // adjust to position vertically
    right: 425, // adjust to position horizontally
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center', 	  	 
    gap: 1,
  },

  wideCellPage3: {
    fontFamily: 'Roboto',
    fontSize: 7,
    right: 45,
    width: 120,         // Wider cell to accommodate longer text
    textAlign: 'center',
    overflow: 'hidden', // Hide overflowed text if it's too long
    textOverflow: 'ellipsis', // Adds "..." at the end if the text overflows (optional)
  },

  percentageTextPage3: {
    fontSize: 10,
    fontWeight: 'bold',
    textAlign: 'center',
  },

  TitleBottomBorderPage3: {
    top: 6,
    width: 350, // Adjust this width as needed to control the length of the border
    height: 1, // Thickness of the border
    backgroundColor: '#bfbfbf',
    marginTop: 2, // Space between the text and the border
    fontFamily: 'Roboto'
  },

  highlightedHeaderPage3: {
    backgroundColor: '#CCECFF', // The highlighted background color for important row
  },

  boldCellTextPage3: {
    fontSize: 10,
    fontWeight: 'bold',
    fontFamily: 'Roboto',
    fontSize: 7
  },

  highlightedCellPage3: {
    backgroundColor: '#f0f0f0', // Add background color for highlighted cells
  },

  finalValueRowPage3: {
    backgroundColor: '#CCECFF',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },

  rowPage3: {
    flexDirection: 'row',
    justifyContent: 'space-between',

  },

  leftContainerPage3: {
    flexDirection: 'column',
    justifyContent: 'flex-start',
    padding: 10,
    marginBottom: 10,
    width: 258,
    height: 565,
    alignItems: 'stretch',
  },

  leftColumnPage3: {
    width: '60%',
    paddingRight: 10,
  },

  rowContainerPage3: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: '300%',   // Ensure it takes up the full width of the parent
    marginBottom: 5, // Reduce the margin between rows
  },

  labelPage3: {
    fontSize: 10,
    marginBottom: 2,
    marginRight: 5,
  },

  valuePage3: {
    paddingLeft: 3,
    paddingTop: 2,
    paddingBottom: 2,
    paddingRight: 3,
    fontSize: 10,
    marginBottom: 5,
    backgroundColor: '#f0f0f0',
  },

  valueContainerPage3: {
    flex: 1,
    paddingLeft: 150,   // Adjusted padding to prevent overflow
    paddingRight: 2,
    alignItems: 'center',
    flexDirection: 'row',
  },

  GeneratedImagePage3: {
    position: "absolute",
    top: 12,
    width: 273,
    height: 350,
    marginBottom: 10,
  },

  rightContainerPage3: {
    position: 'relative',
    top: 30,
    width: 250,
    height: 562,
    alignItems: 'flex-start',
    backgroundColor: '#CCECFF',
    paddingRight: 5,
    // marginLeft: -20, // Removed or adjusted
  },

  rightColumnPage3: {
    top: 5,
    left: 50,
    width: '30%',
    width: 200,
    padding: 5,
    margin: 0,
  },

  headerPage3: {
    backgroundColor: '#CCECFF',
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: 8,
  },

  rightHeaderPage3: {
    fontFamily: "Roboto",
    fontWeight: 'bold',
    color: "#292929",
    fontSize: 7,
    marginTop: 22,
    marginBottom: 5,
    right: 23
  },


  paragraphPage3: {
    fontFamily: "Roboto",
    fontSize: 6,
    marginBottom: 5,
    fontWeight: 400,
    right: 23
  },


  //PAGE 4


  pagePage4: {
    padding: 20,
    backgroundColor: '#ffffff',
  },

  parentContainerPage4: {
    position: 'relative',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    width: '100%',
    maxHeight: '100%',  // Restrict the container to not exceed the page height
    paddingBottom: 5,
  },

  leftContainerPage4: {

  },

  divPage4dvs: {
    marginTop: -10, // Moves it up without messing with layout
  },

  dvsHeaderDiv: {
    position: 'absolute',
    top: 195,
    left: 10
  }, 


  dataContainerPage4: {
    flexDirection: 'row',
    backgroundColor: '#f2f2f2',
    justifyContent: 'flex-end',
    paddingRight: 5,
    height: 11,
    width: 130,
    left: 143
  },

  textDataPage4: {
    fontSize: 6,
    fontFamily: 'Roboto',
    fontWeight: '500',
    textAlign: 'right',       // Align text to the right
    paddingRight: 10,         // Add padding to the right
  },

  LeftSectionPage4: {
    flexDirection: 'column',
    justifyContent: 'flex-start',
    padding: 10,
    marginBottom: 10,
    width: 258,
    height: 565,
    alignItems: 'stretch',
  },

  paddingSpacePage4: {
    paddingTop: 6,
    paddingBottom: 6,
  },

  TitleBottomBorderPage4: {
    top: 2,
    width: 350, // Adjust this width as needed to control the length of the border
    height: 1, // Thickness of the border
    backgroundColor: '#bfbfbf',
    marginTop: 2, // Space between the text and the border
    fontFamily: 'Roboto'
  },

  TitleSectionPage4: {
    fontFamily: 'Roboto',
    fontSize: 10,
    marginBottom: 5,
    top: 5,
    fontWeight: '900',
    color: '#006080',
    width: 300
  },

  SquareTitlePage4: {
    height: 14,
    justifyContent: 'center', 
    backgroundColor: '#CCECFF',
    width: 273,
  },

  TitlePage4: {
    left: 5,
    flexDirection: 'column',      // Stack items vertically
    justifyContent: 'flex-end',   // Align content to the bottom
    flexShrink: 0,
    justifyContent: 'center',           // Prevent shrinking           
    fontSize: 8,
    fontFamily: 'Roboto',
    fontWeight: 'bold',
    lineHeight: 1,
  },

  LeftSquarePage4: {
    width: 96,
    height: 47,
    backgroundColor: '#d7e3ba',
    justifyContent: 'center', // Center vertically
    alignItems: 'center', // Center horizontally
  },

  RightSquarePage4: {
    width: 96,
    height: 47,
    backgroundColor: '#dce7f2',
    bottom: 47,
    left: 177,
    justifyContent: 'center', // Center vertically
    alignItems: 'center', // Center horizontally
  },

  TextSquarePage4: {
    alignItems: 'center',
    fontFamily: 'Roboto',
    fontWeight: '900',
  },

  BarImagePage4: {
    width: 274,
    height: 45,
    bottom: 35
  },

  GraphImagePage4: {
    position: "absolute",
    top: 405,                     // ✅ Keep the original positioning
    left: 7,                   // ✅ Ensure no shift
    width: 310,                   // ✅ Keep the container width unchanged
    height: 210,                  // ✅ Keep the container height unchanged
    justifyContent: 'center',      // ✅ Center inside container
    alignItems: 'center',          // ✅ Keep alignment
    overflow: 'hidden',            // ✅ Prevent stretching
},

  graphInsideContainer: {
    width: '100%',             // 🔥 Ensures the image takes full width of container
    height: '100%',            // 🔥 Ensures it takes full height
    resizeMode: 'contain',     // 🔥 Keeps aspect ratio, prevents stretching
  },

  TableImagePage4: {
    marginTop: 10,
    position: 'relative',   // Keep the image in the normal document flow
    zIndex: 9999,              // Control if it's in front or behind other elements (lower values mean behind)
    alignSelf: 'center',
    left: 25,
    width: 180,
    height: 120,
  },

  ImagePage4: {
    width: '100%',          // Make the image take up the full width of its container
    height: '100%',         // Keep the aspect ratio intact
  },

  rowContainerPage4: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: '100%',   // Use 100% instead of 300% to avoid overflow
    marginBottom: 5,
  },

  labelPage4: {
    fontSize: 10,
    marginBottom: 2,
    marginRight: 5,
  },

  valuePage4: {
    paddingLeft: 3,
    paddingTop: 2,
    paddingBottom: 2,
    paddingRight: 3,
    fontSize: 10,
    marginBottom: 5,
    backgroundColor: '#f0f0f0',
  },

  valueContainerPage4: {
    flex: 1,
    paddingLeft: 150,   // Adjusted padding to prevent overflow
    paddingRight: 2,
    alignItems: 'center',
    flexDirection: 'row',
  },

  CarImagePage4: {
    width: 190,
    height: 80,
    marginBottom: 10,
  },

  rightContainerPage4: {
    position: 'relative',
    top: 30,
    width: 250,
    height: 562,
    alignItems: 'flex-start',
    backgroundColor: '#CCECFF',
    paddingRight: 5,
    // marginLeft: -20, // Removed or adjusted
  },

  sectionHeaderPage4: {
    fontSize: 12,
    fontWeight: 'bold',
    marginBottom: 5,
    marginTop: 10,
  },

  rightColumnPage4: {
    top: 5,
    left: 50,
    width: '30%',
    width: 200,
    padding: 5,
    margin: 0,
  },

  paragraphPage4: {
    fontFamily: "Roboto",
    fontSize: 6,
    marginBottom: 5,
    right: 23

  },

  SquareTotalDiminishedValuePage4: {
    display: 'flex',              // Flexbox layout
    width: 160,                   // Width in points (React-PDF uses point units)
    height: 14,                   // Height in points
    paddingTop: 3,                // Padding top (React-PDF does not support shorthand for padding)
    paddingBottom: 3,             // Padding bottom
    paddingLeft: 2,               // Padding left
    paddingRight: 2,              // Padding right
    alignItems: 'center',         // Align items to the center vertically
    flexShrink: 0,                // Prevent shrinking
    backgroundColor: '#C5D9F1',
  },


  TextSquareDimishedValuePage4: {
    display: 'flex',
    fontFamily: 'Roboto',
    width: 101,                   // Width in points
    height: 8,                    // Height in points
    flexDirection: 'column',      // Column direction
    justifyContent: 'center',   // Justify content to the end
    flexShrink: 0,                // Prevent shrinking
    color: '#292929',             // Text color
    fontSize: 7,                  // Font size in point         // Normal font style
    fontWeight: 700,              // Font weight (bold)
    lineHeight: 1,
    alignItems: 'center',
    textAlign: 'center'
  },

  SquarePricePage4: {
    display: 'flex',              // Flexbox layout
    width: 160,                   // Width in points
    height: 53,                   // Height in points
    paddingTop: 2,                // Padding top
    paddingBottom: 2,             // Padding bottom
    paddingLeft: 3,               // Padding left
    paddingRight: 3,              // Padding right
    justifyContent: 'center',     // Center content horizontally
    alignItems: 'center',         // Center content vertically
    flexShrink: 0,                // Prevent shrinking
    border: '1px solid #4F81BD',  // Border with specified color
    backgroundColor: '#FFF',
    marginTop: 10,                // Add space above the component
    marginBottom: 10,
  },

  ValueSquarePricePage4: {
    top: 10,
    color: '#000',                // Text color
    fontSize: 27,                 // Font size in points
    fontWeight: 900,              // Semi-bold font weight
    lineHeight: 1,                // Set line height to 1 for better centering
    textAlign: 'center',          // Center text horizontally within its container
    flexGrow: 1,                  // Allow this element to grow
  },

  containerFinalPercentagePage4: {
    height: 16,
    width: 160,                // Fixed width for visibility
    flexDirection: 'row',       // Align items in a row
    alignItems: 'center',       // Center vertically
    bottom: 10,
    left: 20
  },

  finalPercentagePage4: {
    top: 2,
    fontSize: 7,                // Adjust font size as needed
    fontWeight: 'bold',// Optional: make the text bold
    color: '#000000',           // Dark color for contrast
    marginLeft: 'auto'          // Push text to the right within the container
  },

  finalContainerPage4: {
    flexDirection: 'row', // Aligns children horizontally
    justifyContent: 'center', // Centers the items horizontally
    alignItems: 'center', // Aligns items vertically in the center
    position: 'absolute', // Keeps the entire row separate from the rest of the layout
    top: 0, // Adjust as needed to place it correctly in your layout
    width: '100%', // Ensures the row takes the full width of the screen
    zIndex: 9999, // Keep it above other elements if necessary
  },

  containerFinalHighPage4: {
    marginHorizontal: 10, // Space between containers
    backgroundColor: '#f0f0f0', // Optional styling for visibility
    padding: 5, // Optional padding for inner spacing
  },

  finalContainerPage4: {
    position: 'relative',   // Ensures that absolutely positioned children are positioned relative to this container
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 20,
    top: -70,
    left: -50
  },

  containerFinalHighPage4: {

  },

  finalHighValueTextPage4: {
    fontFamily: 'Roboto',
    fontSize: 5,
    fontWeight: "bold"
  },

  containerFMVPage4: {

  },

  postRepairTextPage4: {
    fontFamily: 'Roboto',
    fontSize: 5,
    fontWeight: "bold"
  },


  containerDiminishedValuePage4: {

  },

  diminishedValueTextPage4: {
    fontFamily: 'Roboto',
    fontSize: 5,
    fontWeight: "bold"
  },


  // END OF PAGE 4







  // END OF PAGE 5


  pagePage5: {
    padding: 20,
    backgroundColor: '#ffffff',
  },

  parentContainerPage5: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    width: '100%',
    maxHeight: '100%',  // Restrict the container to not exceed the page height
    paddingBottom: 5,
  },

  containerDataPage5: {
    top: 15,
    textAlign: 'center',
    width: '100%',
    maxWidth: '5000px', // Increase this value as per your requirement
    margin: '0 auto', // Center the container if necessary
    padding: '10px', // Optional for better spacing
  },

  dataContainerPage5: {
    right: 15,
    display: 'flex',
    flexDirection: 'row', // Ensures items are placed next to each other horizontally
    width: 280,
    height: 155,
    padding: 5,
    justifyContent: 'space-between', // Space out the text and image containers
    alignItems: 'center', // Vertically center the items
  },

  insideLeftContainerPage5: {
    textAlign: 'left',
    width: '45%', // Adjust the width to allow enough space for both containers
    height: 'auto', // Let the height adjust based on content
  },

  textInsideContainerPage5: {
    color: '#808080',
    fontFamily: "Roboto",
    fontSize: 6,
    fontWeight: '400',
    lineHeight: 'normal',
  },

  insideRightContainerPage5: {
    width: '60%', // Ensure this container takes the remaining space
    height: 'auto', // Adjust the height to match the content or image
    padding: 5,
    textAlign: 'right'
  },

  imageInsideContainerPage5: {
    width: '100%', // Ensure the image fits within the container
    height: 'auto', // Maintain the aspect ratio of the image
    justifyContent: 'flex-end', // Align the image to the right
    display: 'flex',
    left: 15

  },

  leftContainerPage5: {

  },

  leftColumnPage5: {
  },

  LeftSectionPage5: {
    flexDirection: 'column',
    justifyContent: 'flex-start',
    padding: 10,
    marginBottom: 10,
    width: 258,
    height: 565,
    alignItems: 'stretch',
  },

  TitleSectionPage5: {
    fontFamily: 'Roboto',
    fontSize: 10,
    marginBottom: 5,
    fontWeight: '900',
    color: '#006080',
    width: 300
  },

  imageContainerPage5: {
    top: 7,
    width: 6,
    height: 6
  },

  imageContainer2Page5: {
    top: 7,
    width: 6,
    height: 6
  },

  imageContainer3Page5: {
    top: 20,
    width: 6,
    height: 6
  },

  TitleBottomBorderPage5: {
    width: 350, // Adjust this width as needed to control the length of the border
    height: 1, // Thickness of the border
    backgroundColor: '#bfbfbf',
    marginTop: 2, // Space between the text and the border
    fontFamily: 'Roboto',
    top: 5
  },

  SquareTitlePage5: {
    width: 280,               // Width adjusted for the title container
    height: 'auto',           // Allow the height to adjust based on content
    paddingTop: 3,
    right: 10,
    paddingBottom: 3,
    paddingLeft: 2,
    paddingRight: 2,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',  // Center the title horizontally
    alignItems: 'center',
    backgroundColor: '#CCECFF',

  },

  RightTitlePage5: {
    top: 22,
    fontFamily: "Roboto",
    color: "#292929",
    fontSize: 7,
    fontWeight: "bold",
    bottom: 22
  },


  FirstThreeImagesPage5: {
    left: 35,
    width: 245,
    height: 119
  },

  NaaImagePage5: {
    right: 8,
    top: 10,
    width: 280,
    height: 200,
  },

  TitlePage5: {
    fontFamily: "Roboto",
    fontSize: 8,
    fontWeight: "bold",
    textAlign: 'center',       // Center the text inside the container
    width: 'auto',             // Ensure the text takes as much space as needed
    lineHeight: 1.2,           // Add some spacing between lines (optional)
  },

  LeftSquarePage5: {

  },

  TextLeftSquarePage5: {

  },

  BarImagePage5: {
    width: 232,
    height: 35
  },

  GraphImagePage5: {
    width: 216,
    height: 175
  },

  TableImagePage5: {
    alignSelf: 'center',
    width: 130,
    height: 95
  },


  rowContainerPage5: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: '100%',   // Use 100% instead of 300% to avoid overflow
    marginBottom: 5,
  },

  labelPage5: {
    fontSize: 10,
    marginBottom: 2,
    marginRight: 5,
  },

  valuePage5: {
    paddingLeft: 3,
    paddingTop: 2,
    paddingBottom: 2,
    paddingRight: 3,
    fontSize: 10,
    marginBottom: 5,
    backgroundColor: '#f0f0f0',
  },

  valueContainerPage5: {
    flex: 1,
    paddingLeft: 150,   // Adjusted padding to prevent overflow
    paddingRight: 2,
    alignItems: 'center',
    flexDirection: 'row',
  },

  CarImagePage5: {
    width: 190,
    height: 80,
    marginBottom: 10,
  },

  rightContainerPage5: {
    position: 'relative',
    top: 30,
    width: 250,
    height: 562,
    alignItems: 'flex-start',
    backgroundColor: '#CCECFF',
    paddingRight: 5,
    // marginLeft: -20, // Removed or adjusted
  },


  rightColumnPage5: {
    top: 5,
    left: 50,
    width: '30%',
    width: 200,
    padding: 5,
    margin: 0,
  },

  sectionHeaderPage5: {
    fontSize: 12,
    fontWeight: 'bold',
    marginBottom: 5,
    marginTop: 10,
  },

  paragraphPage5: {
    fontFamily: "Roboto",
    fontSize: 6,
  },

  tableContainerPage5: {
    top: 15,
    height: 33,
    width: 180,
    borderWidth: 1,            // Ensure the border width is set
    borderColor: '#4F81BD',     // Ensure the border color is set
    alignSelf: 'center',
  },

  firstPartContainerPage5: {
    height: 11,
    backgroundColor: '#c7daf2',
    borderBottomWidth: 1,       // Adding borders for table cells if needed
    borderColor: '#4F81BD',

  },

  secondPartContainerPage5: {

  },

  firstPartTextPage5: {
    top: 1,
    left: 5,
    fontFamily: 'Roboto',
    fontSize: 5,
    fontWeight: 'bold'
  },

  secondPartTextPage5: {
    padding: 2,
    left: 5,
    fontFamily: 'Roboto',
    fontSize: 5,
  },

  secondPartMailPage5: {
    padding: 2,
    left: 5,
    fontFamily: 'Roboto',
    fontSize: 5,
  },

  SquareTotalDiminishedValuePage5: {
    display: 'flex',              // Flexbox layout
    width: 160,                   // Width in points (React-PDF uses point units)
    height: 14,                   // Height in points
    paddingTop: 3,                // Padding top (React-PDF does not support shorthand for padding)
    paddingBottom: 3,             // Padding bottom
    paddingLeft: 2,               // Padding left
    paddingRight: 2,              // Padding right
    alignItems: 'center',         // Align items to the center vertically
    flexShrink: 0,                // Prevent shrinking
    backgroundColor: '#C5D9F1',
  },


  TextSquareDimishedValuePage5: {
    display: 'flex',              // Flexbox layout
    width: 101,                   // Width in points
    height: 8,                    // Height in points
    flexDirection: 'column',      // Column direction
    justifyContent: 'flex-end',   // Justify content to the end
    flexShrink: 0,                // Prevent shrinking
    color: '#292929',             // Text color
    fontSize: 8,                  // Font size in point         // Normal font style
    fontWeight: 700,              // Font weight (bold)
    lineHeight: 1,
  },

  SquarePricePage5: {
    display: 'flex',              // Flexbox layout
    width: 160,                   // Width in points
    height: 53,                   // Height in points
    paddingTop: 2,                // Padding top
    paddingBottom: 2,             // Padding bottom
    paddingLeft: 3,               // Padding left
    paddingRight: 3,              // Padding right
    justifyContent: 'center',     // Center content horizontally
    alignItems: 'center',         // Center content vertically
    flexShrink: 0,                // Prevent shrinking
    border: '1px solid #4F81BD',  // Border with specified color
    backgroundColor: '#FFF',
    marginTop: 10,    // Add space above the component
    marginBottom: 10,
  },

  ValueSquarePricePage5: {
    width: 76,                    // Width in points
    flexShrink: 0,                // Prevent shrinking
    color: '#000',                // Text color
    textAlign: 'center',          // Align text to center
    fontSize: 24,                 // Font size in points         // Normal font style (you can omit this since it's the default)
    fontWeight: 600,              // Semi-bold font weight
    lineHeight: 1,
  },


  uncheckedBoxPage5: {
    width: 7,
    height: 7,
    backgroundColor: '#f2f2f2', // background for unchecked box,
    borderRadius: '50%',
  },

  checkboxPage5: {
    top: 32,
    left: 13,
    width: 7,
    height: 7,
    position: 'relative',
    backgroundColor: '#0073ff',
    borderRadius: '50%',
  },

  finaltextContainerPage5: {
    right: 5
  },

  yesPage5: {
    top: 24,
    left: 35,
    fontFamily: "Roboto",
    fontSize: 7,
  },

  InspectionPage5: {
    top: 15,
    left: 54,
    fontFamily: "italicFamily",
    fontSize: 7,
    fontWeight: 99999
  }

  // END OF PAGE 5

});

export default styles;